import { Box } from '@mui/material';
import { LinkSimple } from '@phosphor-icons/react';
import React from 'react';
import type { ProviderIconComponent } from '../types';

interface ProviderIconBadgeProps {
  IconComponent: ProviderIconComponent | null;
  brandColor: string;
  size?: number;
  isDark: boolean;
}

function hexToRgb(hex: string): string {
  const clean = hex.replace('#', '');
  const r = parseInt(clean.substring(0, 2), 16);
  const g = parseInt(clean.substring(2, 4), 16);
  const b = parseInt(clean.substring(4, 6), 16);
  return `${r}, ${g}, ${b}`;
}

const ProviderIconBadge: React.FC<ProviderIconBadgeProps> = ({
  IconComponent,
  brandColor,
  size = 32,
  isDark,
}) => {
  const rgb = hexToRgb(brandColor);
  const bgAlpha = isDark ? '0.15' : '0.10';
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '8px',
        backgroundColor: `rgba(${rgb}, ${bgAlpha})`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      {IconComponent ? (
        <IconComponent size={size * 0.55} color={brandColor} />
      ) : (
        <LinkSimple size={size * 0.5} weight='bold' color={brandColor} />
      )}
    </Box>
  );
};

export default ProviderIconBadge;
